export default __webpack_public_path__ + "static/signInBackGround-2b4fec4407e5b9d51f8d9260a8c13e33.png";